<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="TraderecordRespVo" ref="queryForm" label-width="auto" size="small" inline>

<!--        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('startDate')" prop="startDate">
            <el-date-picker
              v-model="TraderecordRespVo.startDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsStart"
              popper-class="no-now-btn"
              class="full-width"
              :clearable="false"
              :editable="false"
            />
          </el-form-item>
        </el-col>


        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('endDate')" prop="endDate">
            <el-date-picker
              v-model="TraderecordRespVo.endDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsEnd"
              popper-class="no-now-btn"
              class="full-width"
              :clearable="false"
              :editable="false"
            />
          </el-form-item>
        </el-col>-->
        <el-form-item :label="$t('date')" prop="dateRange">

          <el-date-picker

              v-model="TraderecordRespVo.dateRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"

              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="full-width"
              :default-time="['00:00:00','23:59:59']"
              :picker-options="pickerOptions"
          />

        </el-form-item>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('currency')"prop="currency">
            <div class="input-with-more">
              <el-input v-model="TraderecordRespVo.currency"  clearable />
<!--              <el-button type="text" @click="openMoreDialog('orderNo')">More</el-button>-->
            </div>
          </el-form-item>
        </el-col>



        <el-col :span="24">
          <el-form-item style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 20px;" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>
        </el-col>

        <!-- 通用 More 弹窗（只保留一个）  :title="getDialogTitle" -->
        <el-dialog
          :visible.sync="moreDialogVisible"
          width="800px"
          @close="onMoreDialogClose"
        >
          <el-input
            type="textarea"
            :rows="8"
            v-model="moreInput"
            :placeholder="`请输入多个值,请使用英文逗号隔开，做到输入1000个值。例如：\nVALUE1\nVALUE2, VALUE3`"
          />
          <span slot="footer">
    <el-button @click="closeMoreDialog">取消</el-button>
    <el-button type="primary" @click="confirmMoreInput">确定</el-button>
  </span>
        </el-dialog>
      </el-form>
    </el-card>

    <div class="action-toolbar">

      <el-button
        v-if="hasPermission('admin/showMerFormsTradeListInfo', 'downExcel')"
        :disabled="!hasSearched"
        :loading="downloadLoading"
        @click="handleDownload"
        type="primary"
        icon="el-icon-download"
      >
        {{ $t('button.download') }}
      </el-button>

    </div>

    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >
        <el-table-column prop="trDate" :label="$t('showMerFormsTradeListInfo.trdate')" width="210"></el-table-column>
        <el-table-column prop="succCnt" :label="$t('showMerFormsTradeListInfo.TotalsuccCnt')" width="210"></el-table-column>
        <el-table-column prop="succAmount" :label="$t('showMerFormsTradeListInfo.TotalsuccAmount')"></el-table-column>
        <el-table-column prop="protestCnt" :label="$t('showMerFormsTradeListInfo.protestCnt')"></el-table-column>
        <el-table-column prop="protestAmount" :label="$t('showMerFormsTradeListInfo.protestAmount')"></el-table-column>
        <el-table-column prop="protestRate" :label="$t('showMerFormsTradeListInfo.ProtestRate')" width="110"></el-table-column>
        <el-table-column prop="unnAmount" :label="$t('showMerFormsTradeListInfo.TotalunnAmount')"></el-table-column>
        <el-table-column prop="unnRate" :label="$t('showMerFormsTradeListInfo.unnRate')"></el-table-column>


      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>
  </div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {
      pickFirstDate: null,

      pickerOptions: {
        onPick: ({ minDate, maxDate }) => {
          // 记录第一次选择的日期
          this.pickFirstDate = minDate.getTime();
          // 如果已经选择了两个日期，重置
          if (maxDate) {
            this.pickFirstDate = null;
          }
        },
        disabledDate: (time) => {
          // 如果已经选择了第一个日期，限制30天范围
          if (this.pickFirstDate) {
            const day = 30 * 24 * 3600 * 1000; // 30天
            const maxTime = this.pickFirstDate + day;
            const minTime = this.pickFirstDate - day;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
          return false;
        }
      },
      loading: false,
      TraderecordRespVo: {
        dateRange:[],
        startDate: "",
        endDate: "",
        currency: "",

      },
      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询

      downloadLoading: false,
      tableData: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",


    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    // 组件创建后设置默认时间
    //this.setDefaultTime(); //时间设置
  },
  computed:{

  },
  methods: {
    hasPermission,
    //时间格式
    formatTime(isoTime) {
      if (!isoTime) return '-';

      try {
        const date = new Date(isoTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return isoTime; // 如果解析失败，返回原值
      }},

    setDefaultTime() {
      // 只有在当前时间为空时才设置默认值
      if (!this.TraderecordRespVo.startDate) {
        this.TraderecordRespVo.startDate = this.getDefaultStartTime();
      }
      if (!this.TraderecordRespVo.endDate) {
        this.TraderecordRespVo.endDate = this.getCurrentTime();
      }
    },
    // 获取当前时间字符串，格式：YYYY-MM-DD HH:mm:ss
    getCurrentTime() {
      // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(23, 59, 59, 999); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 获取当前时间往前推 1 年
    getDefaultStartTime() {
      /*    const now = new Date();
          const oneYearAgo = new Date(now);
          oneYearAgo.setFullYear(now.getFullYear() - 1);
          return this.formatDateTime(oneYearAgo);*/
      const now = new Date();

      // 1. 获取当前时间的毫秒时间戳
      const currentTimestamp = now.getTime();

      // 2. 计算2天的毫秒数 (2 * 24小时 * 60分钟 * 60秒 * 1000毫秒)
      const twoDaysInMs = 2 * 24 * 60 * 60 * 1000;

      // 3. 用当前时间戳减去2天的毫秒数
      const twoDaysAgoTimestamp = currentTimestamp - twoDaysInMs;

      // 4. 基于新的时间戳创建日期对象
      const twoDaysAgo = new Date(twoDaysAgoTimestamp);

      // 5. 重置为当天 00:00:00 (注意：这里重置的是"2天前"那天的0点)
      twoDaysAgo.setHours(0, 0, 0, 0);

      return this.formatDateTime(twoDaysAgo);
    },
    // 格式化日期为 'YYYY-MM-DD HH:mm:ss'
    formatDateTime(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;

      try {

        if (!this.TraderecordRespVo.dateRange || this.TraderecordRespVo.dateRange.length === 0) {
          this.$message.warning(this.$t('selectDateRange'));

          return;
        }
        if(this.TraderecordRespVo.dateRange){

          this.TraderecordRespVo.startDate =
              this.TraderecordRespVo.dateRange[0];


          this.TraderecordRespVo.endDate =
              this.TraderecordRespVo.dateRange[1];

        }

        const params = {
          startDate: this.TraderecordRespVo.startDate || undefined,
          endDate: this.TraderecordRespVo.endDate || undefined,
          currency: this.TraderecordRespVo.currency || undefined,

          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/traderecord/mer/forms/traderecord/list',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        if (err.response){
          console.log("测试登录过期 - 完整错误对象:", err.response);
          console.log("测试登录过期 - 状态码:", err.response.status);
          console.log("测试登录过期 - 响应数据:", err.response.data);
          console.log("测试登录过期 - 响应数据(JSON):", JSON.stringify(err.response.data, null, 2));

          if(err.response.status === 401){
            const message = err.response.data.message || '登录已经过期';
            console.log("登录失效消息:", message);
            this.$message.error(message);

            // 清除本地 token 并跳转到登录页
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user");
            this.$router.push('/login');
          }
        }
        console.error('查询订单失败:', err);
        this.$message.error('网络错误，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 下载
    // 下载报表
    async handleDownload() {
      this.downloadLoading = true;
      this.$message.info(this.$t('DownloadInfo'));

      try {
        if (!this.TraderecordRespVo.dateRange || this.TraderecordRespVo.dateRange.length === 0) {
          this.$message.warning(this.$t('selectDateRange'));
          return;
        }
        if(this.TraderecordRespVo.dateRange){

          this.TraderecordRespVo.startDate =
              this.TraderecordRespVo.dateRange[0];


          this.TraderecordRespVo.endDate =
              this.TraderecordRespVo.dateRange[1];

        }

        const params = {
          startDate: this.TraderecordRespVo.startDate || undefined,
          endDate: this.TraderecordRespVo.endDate || undefined,
          currency: this.TraderecordRespVo.currency || undefined,
        };


        const res = await this.$axios.post('/api/traderecord/mer/forms/traderecord/downExcel', params, {
          responseType: 'blob'
        });


        if (res.data.type === 'application/json') {
          const reader = new FileReader();
          reader.onload = () => {
            const errorMsg = JSON.parse(reader.result);
            this.$message.error(errorMsg.msg || '导出失败');
          };
          reader.readAsText(res.data);
          return;
        }


        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });


        const fileName = `交易报表_${this.formatDateTime(new Date()).replace(/[: ]/g, '')}.xlsx`;


        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {

          const a = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          document.body.appendChild(a);
          a.click();

          // 下载完成后清理内存
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }

        this.$message.success(this.$t('export_success'));
      } catch (error) {
        console.error('下载出错:', error);
        this.$message.error(this.$t('requestFailed'));
      } finally {
        this.downloadLoading = false;
      }
    },
    // 下载表单提交处理
    onDownloadSubmit() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return false; // 阻止表单提交
      }

      this.$message.success('开始生成文件，请查看浏览器下载列表...');

      return true; // 允许表单提交
    },

    // 通用打开弹窗方法
    openMoreDialog(fieldName) {
      this.currentField = fieldName;
      const currentValue = this.TraderecordRespVo[fieldName] || '';
      // 直接显示原始内容（可能含逗号、空格等）
      this.moreInput = currentValue;
      this.moreDialogVisible = true;
    },


    confirmMoreInput() {
      // 只需要去掉 # 前后的空格，保留值内部的其他空格
      const cleanedValue = this.moreInput
        .split('#')
        .map(item => item.trim())  // 去掉每个值的前后空格
        .filter(item => item.length > 0)  // 过滤空值
        .join('#');  // 用 # 重新连接

      this.TraderecordRespVo[this.currentField] = cleanedValue;
      this.closeMoreDialog();

      this.$message.success(`已设置 ${cleanedValue.split('#').length} 个值`);
    },

    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },

  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
/*隐藏此刻*/
.no-now-btn .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/showMerFormsTradeListInfo.vue